module.exports = __webpack_public_path__ + "h5/img/pss.bdde68d0.png";